import React from "react";
import styles from "./StartEndDateCell.module.css";
import {OfferInListDTO} from "../../../../../../../api/generated";

interface StartEndDateCellProps {
    offer: OfferInListDTO
}

export const StartEndDateCell: React.FC<StartEndDateCellProps> = ({offer}) => {

    const formatDateToShortMonth = (dateString: string): string => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
        });
    }

    return <div className={styles.wrapper}>
        <span>{formatDateToShortMonth(offer.startDate)}</span>
        <span>-</span>
        <span className={styles.endDate}>{formatDateToShortMonth(offer.endDate)}</span>
    </div>
}
